let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eHgSV")).then(() => parcelRequire('eGoG9'));